module.exports = __webpack_public_path__ + "img/logo_white.5c48d8c7.svg";